/*eslint-disable*/
import React from 'react';
import DiscountForm from './DiscountForm';

export default function AddDiscount() {
  return <DiscountForm />;
}
